import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styled from '@emotion/styled';
import { isPresent, isBlank } from '@seedlang/utils';

const SegmentedControlWrapper = styled.div`
  display: inline-flex;
  background-color: #e8e8e8;
  border-radius: ${props => props.small ? '19px' : '24px'};
  padding: 2px;
  position: relative;
  gap: 0;
  height: ${props => props.small ? '30px' : '38px'};
  align-items: center;
  opacity: ${props => props.disabled ? '0.5' : '1'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'default'};
`;

const SegmentedControlOption = styled.button`
  width: ${props => props.buttonWidth};
  padding: ${props => props.small ? '6px 13px' : '8px 16px'};
  border: none;
  background: ${props => props.isActive ? '#FFF' : 'transparent'};
  color: ${props => props.isActive ? '#000' : '#666'};
  font-weight: ${props => props.isActive ? '600' : '400'};
  border-radius: ${props => props.small ? '17px' : '22px'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  font-size: ${props => isPresent(props.fontSize) ? props.fontSize : props.small ? '12px' : '14px'};
  box-shadow: ${props => props.isActive ? '0 1px 3px rgba(0,0,0,0.12)' : 'none'};
  white-space: nowrap;
  height: ${props => props.small ? '26px' : '34px'};
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

  &:hover {
    color: ${props => props.isActive ? '#000' : '#333'};
  }

  &:focus {
    outline: none;
  }
`;

@observer
class SegmentedControl extends React.Component {

  @observable buttonWidth;
  handleOptionClick = (value) => {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  constructor(props) {
    super(props);
    if (isBlank(props.buttonWidth)) {
      if (props.small) {
        this.buttonWidth = '77px';
      } else {
        this.buttonWidth = '96px';
      }
    }
  }

  render() {

    return (
      <SegmentedControlWrapper
        small={this.props.small}
        disabled={this.props.disabled}
      >
        {
          this.props.options.map(option => {
            return (
              <SegmentedControlOption
                key={option.value}
                isActive={this.props.activeOption === option.value}
                onClick={() => this.handleOptionClick(option.value)}
                small={this.props.small}
                fontSize={this.props.fontSize}
                buttonWidth={this.buttonWidth}
                disabled={this.props.disabled}
              >
                {option.label}
              </SegmentedControlOption>
            );
          })
        }
      </SegmentedControlWrapper>
    );
  }
}

export default SegmentedControl;